exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-66478c72] .modal-head{padding:16px 20px;border-bottom:1px solid #f1f1f1}.camera-error-tip .text[data-v-66478c72]{font-size:16px;color:#333;text-align:center}.camera-error-tip .text span[data-v-66478c72]{font-weight:500}.blue-btn[data-v-66478c72]{display:inline-block;background:linear-gradient(135deg,#329dfc,#397efd);box-shadow:0 6px 12px 0 rgba(57,126,253,.3);color:#fff;width:96px;height:36px;line-height:36px;font-size:14px;border-radius:4px;text-align:center;cursor:pointer;letter-spacing:1px;margin-bottom:10px}.blue-btn[data-v-66478c72]:hover{background:#397efd}", ""]);

// exports
